import styled from '@emotion/styled';
import {animated, config, useSpring} from 'react-spring';
import {colors} from '@styles/colors';
import {absolutePosition} from '@styles/reusable';
import {useEffect, useState} from 'react';

const Skeleton = styled.div<{ color: SkeletonTheme }>`
  --mainColor: ${({ color }) => (color === SkeletonTheme.GRAY ? colors.gray_50 : colors.mainTextColor)};
  --blurColor: ${colors.white_rgb};
  position: relative;
  background-color: var(--mainColor);
  overflow: hidden;
`;
const Pass = styled.div`
  ${absolutePosition};
  background-image: linear-gradient(
    90deg,
    rgba(var(--blurColor), 0) 0,
    rgba(var(--blurColor), 0.2) 20%,
    rgba(var(--blurColor), 0.5) 60%,
    rgba(var(--blurColor), 0)
  );
  width: 100%;
  height: 100%;
`;

const AnimatedPass = animated(Pass);

export enum SkeletonTheme {
  GRAY = 'gray',
  BLUE = 'blue',
}

interface ISkeletonAnimProps {
  className?: string;
  color?: SkeletonTheme;
  width?: number | string;
  height?: number | string;
}

export const SkeletonAnim = ({ className, width, height, color = SkeletonTheme.GRAY }: ISkeletonAnimProps) => {
  const [flip, set] = useState(false);
  const [animated, setAnimate] = useState(true)
  const spring = useSpring({
    from: { transform: `translate3d(-100%,0,0)` },
    to: { transform: `translate3d(100%,0,0)` },
    reset: true,
    config: config.molasses,
    onRest: () => set(!flip),
  });

  useEffect(() => {
    return () => {
      setAnimate(false)
    }
  }, [])

  return (
    <Skeleton className={className} style={{ height, width }} color={color}>
      {animated && <AnimatedPass style={spring} />}
    </Skeleton>
  );
};

export default SkeletonAnim;
